import React from "react";
import { Dialog } from "../components/Dialog";
import { Flex } from "@chakra-ui/react";
import { Large } from "../components/Type";
import { Header1 } from "../components/Header";
import { InitialRegisterForm } from "../views/RegisterForm";
import { SingleFormAppShell } from "../components/SingleFormAppShell";
import { useRegister } from "../hooks/useRegister";
import { loadCatalog } from "../i18n";
import { Trans, t, msg } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import Head from "../components/Head";

export async function getStaticProps({ params, ...ctx }) {
  const translation = await loadCatalog(ctx.locale);
  return { props: { translation } };
}

const Register = () => {
  const { initialRegistration } = useRegister();
  const { _ } = useLingui();

  return (
    <>
    <SingleFormAppShell title={t`Buat Akun Baru`} description={t`Bergabung dengan Saweria sekarang dan nikmati pengalaman menggunakan platform dengan fitur yang mudah diakses secara praktis dan aman.`}>
      <Dialog marginTop={3}>
        <Flex justifyContent="center" direction="column">
          <Header1 alignSelf="center" />
          <Large m={3} alignSelf="center">
            <Trans>Registrasi</Trans>
          </Large>
          <InitialRegisterForm submit={initialRegistration} />
        </Flex>
      </Dialog>
    </SingleFormAppShell>
  </>
  );
};

export default Register;
